/** Borrower applications inbox — `/review-applications` only (no child segment). */
export function isReviewApplicationsListRoute(url: string): boolean {
  const path = url.split('?')[0].replace(/\/$/, '') || '/';
  return path === '/review-applications';
}

/** View / review workspace under borrower applications (includes KYC deep links). */
export function isReviewApplicationsDetailRoute(url: string): boolean {
  const path = url.split('?')[0];
  return /\/review-applications\/(view|edit)(?:\/|$)/.test(path);
}

/** Facility Product list — `/facility-configuration/product-setup` only (no child segment). */
export function isProductSetupListRoute(url: string): boolean {
  const path = url.split('?')[0].replace(/\/$/, '') || '/';
  return path === '/facility-configuration/product-setup';
}

/** Configure Template workspace under Facility Product. */
export function isProductSetupConfigureRoute(url: string): boolean {
  const path = url.split('?')[0];
  return /\/facility-configuration\/product-setup\/configure(?:\/|$)/.test(path);
}

/** Borrower packages list / detail / create (parent of facility workspace). */
export function isBorrowerPackagesParentRoute(url: string): boolean {
  const path = url.split('?')[0].replace(/\/$/, '') || '/';
  return (
    path === '/facility-configuration/borrower-packages' ||
    path === '/facility-configuration/borrower-packages/detail' ||
    path === '/facility-configuration/borrower-packages/create'
  );
}

/** Facility workspace / Configure form under Borrower Packages. */
export function isBorrowerFacilityWorkspaceRoute(url: string): boolean {
  const path = url.split('?')[0];
  return /\/facility-configuration\/borrower-packages\/(facility|facility-form)(?:\/|$)/.test(path);
}
